module.exports = __webpack_public_path__ + "static/img/jdd-dk.9b0e5cbb.png";